import request from './request'
import { HOST } from './url'

/** 查询所有经营类目 */
export function queryAllCategorys() {
	return request
		.get('/api/common/queryAllCategorys')
		.then((data) => data.list)
}

/** 查询品牌列表 */
export function getBrandList() {
	return request
		.get('/api/business_join/getBrandList')
		.then((data) => data.list)
}

/** 品牌库搜索 */
export function searchBrands(bname: string) {
	return request
		.get('/api/business_join/searchBrands', { params: { bname } })
		.then((data) => data.list)
}

/** 品牌详情接口 */
export function brandView(brand_id: string) {
	return request.get('/api/business_join/brandView', { params: { brand_id } })
}

/** 新增编辑品牌 */
export function saveBrand(data: any) {
	return request.post('/api/business_join/saveBrand', {
		...data,
		trademark_url: data?.trademark_url?.join(','),
		transfer_url: data?.transfer_url?.join(','),
		relate_cat_ids: data?.relate_cat_ids?.join(','),
		second_auth_url: data?.second_auth_url?.join(','),
		brand_authorize_url: data?.brand_authorize_url?.join(','),
	})
}

/** 删除品牌 */
export function delBrand(brand_id: string) {
	return request.post('/api/business_join/delBrand', { brand_id })
}

/** 资质协议文件上传地址 */
export const FILE_UPLOAD_URL = HOST + '/api/business_join/uploadContractFile'

/** 删除资质协议文件 */
export function delContractFile(file_id: string) {
	return request.post('/api/business_join/delContractFile', { file_id })
}

/** 查询店铺经营信息 */
export function queryManageInfo() {
	return request.get('/api/business_join/queryManageInfo').then((data) => {
		let { store_list, brand_list, contract_list } = data
		store_list?.length || (store_list = [{ cat_list: [] }])
		data.store_list = store_list
		data.brand_list = (brand_list || []).map((item: any) => {
			item.trademark_url = (item.trademark_url || '')
				.split(',')
				.filter(Boolean)
			item.transfer_url = (item.transfer_url || '')
				.split(',')
				.filter(Boolean)
			item.relate_cat_ids = item.relate_categorys.map(
				(item: any) => item.cat_id
			)
			item.second_auth_url = (item.second_auth_url || '')
				.split(',')
				.filter(Boolean)
			item.brand_authorize_url = (item.brand_authorize_url || '')
				.split(',')
				.filter(Boolean)
			delete item.relate_categorys
			return item
		})
		data.contract_list = contract_list || []
		return data
	})
}

/** 保存店铺经营信息 */
export function saveStoreInfo({ store_list }: any) {
	store_list = store_list.map((store: any) => {
		const { cat_list, ...rest } = store
		return {
			...rest,
			cate_id_arr: cat_list.map((item: any) => item.cat_id),
		}
	})
	return request.post('/api/business_join/saveStoreInfo', { store_list })
}

/** 删除经营店铺 */
export function delStore(store_id: string) {
	return request.post('/api/business_join/delStore', { store_id })
}
